/**
 * Trigger a modal with a contact form 7 form.
 *
 * The modal HTML element should have the attribute data-modalform="<modal unique ID>".
 *
 *
 * The trigger (button / anchor) element should have the attribute data-modalform_target="<modal unique ID>" which will be used to identify the modal to open.
 * the trigger (button / anchor) element should also need the attribute data-form_input_name="<form input name target>, <content to set/pass in the form input target>".
 * the trigger (button / anchor) element should also need the attribute data-form_input_data="<content to set/pass to the form input target>".
 *
 * @license Copyright 2025, Oscar Rey Tajes. All rights reserved.
 * @author: Oscar Rey Tajes, oscar.rey.tajes@gmail.com
 *
 * @param data-webgldots_target=".xxx", optional. If present, will set the target element to apply the effect, value in css selector format, default first child of the container element
 */

import { getConfigByAtt } from './attributesToConfigObj'
import ModalWP from './ModalWP'

const hyphenToCamelcase = str => {
	return str.replace(/-([a-z])/g, k => k[1].toUpperCase())
}

document.addEventListener('DOMContentLoaded', () => {
	const attributeId = 'modalform'
	const modals = document.querySelectorAll(`[data-${attributeId}]`)

	if (!modals.length) return

	const ModalForm = class {
		constructor(targetDOMElement, config = {}) {
			const { modalform = 'modal', inputtarget = false } = config

			this.modalContent = targetDOMElement
			this.modalID = modalform

			this.modal = new ModalWP(this.modalContent, {
				id: this.modalID,
				form: true,
			})

			// this.form = this.modal.modalContent.querySelector('form')

			this.form = this.modal.popupContent.querySelector('form')

			if (!this.form) return

			// this.setupModal()
			this.bindFoundLinks()

			return this
		}

		replaceTemplateTags = (text, tags) => {
			// Si no hay texto, devolver false
			if (!text) return false

			// Verificar si hay patrones de dobles llaves
			const hasTemplatePattern = /\{\{[^}]*\}\}/g.test(text)

			// Si no encuentra ningún patrón, devolver false
			if (!hasTemplatePattern) return false

			// Reemplazar las plantillas con los valores
			return text.replace(/\{\{([^}]*)\}\}/g, (match, key) => {
				const trimmedKey = key.trim()
				// Si la key está vacía o no existe en tags, devolver string vacío
				if (!trimmedKey || !(trimmedKey in tags)) {
					return ''
				}
				return tags[trimmedKey] || ''
			})
		}

		bindFoundLinks = () => {
			const targetLinks = document.querySelectorAll(`[data-modalform_target="${this.modalID}"]`)

			const titleElement = document.querySelector('h1')
			const titleText = titleElement
				? titleElement.innerHTML.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '')
				: ''

			const tags = {
				title: titleText,
			}

			console.log('tag.title', titleText)

			if (!targetLinks.length) return

			targetLinks.forEach(link => {
				const formInputData = link.dataset['modalform_input_data'] ? link.dataset['modalform_input_data'] : false
				const formInputTargetName = link.dataset['modalform_input_name'] ? link.dataset['modalform_input_name'] : false

				link.addEventListener('click', e => {
					e.preventDefault()

					// Procesar el texto con plantillas de tags tipo {{title}}
					const processedData = this.replaceTemplateTags(formInputData, tags)

					// Si hay plantillas procesadas, usar el resultado procesado, sino usar el original
					const dataToPass = processedData !== false ? processedData : formInputData

					this.passDataToForm(formInputTargetName, dataToPass)

					this.modal.show({ closecallback: this.resetPassedDataToForm })
				})
			})
		}

		passDataToForm = (inputFieldTargetName, data) => {
			this.inputTarget = this.form.querySelector(`input[name="${inputFieldTargetName}"]`)
			this.inputTarget.value = data ? data : ''
		}

		resetPassedDataToForm = () => {
			if (this.inputTarget) this.inputTarget.value = ''
		}
	}

	modals.forEach((modal, index) => {
		const config = getConfigByAtt(modal, attributeId, true)
		// form.modal = new ModalWP(messageOKElement)
		// console.log('config', config)
		modal.modal = new ModalForm(modal, config)
	})
})
